/* eslint-disable no-console */


import { VIDEO_OUTPUT_STATUS } from '@shootsta/common-domain-data';
import _get from 'lodash.get';
import React, { memo, useEffect, useMemo, useState } from 'react';
import { Dropdown, MenuButton, Text } from '../../../ui-kit';
import { RESTRICTED_DOWNLOAD_LABELS } from '../constants';

import {
  appendMetadataToOption,
  canDownloadOriginalQuality,
  getOptionValues,
  isAllowedDownloadOption,
  isAssetExists,
  isAssetFileValid,
  isVideoType,
  transformKeysToOptionsArray } from
'../utils';

import '../styles/_download-asset-menu.scss';













const RESTRICTED_STYLES = {
  opacity: 0.5,
  pointerEvents: 'none'
};

const DownloadAssetMenu = ({
  id,
  asset,
  disabled,
  videoStatus,
  videoId,
  videoProduct,
  includeOriginalQuality,
  children,
  getBynderAssetDownloadUrl
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [bynderDownloadUrl, setBynderDownloadUrl] = useState('');

  const getBynderDownloadUrl = async (metaData, organisationId) => {
    try {
      const parsedMetaData = JSON.parse(metaData);
      const bynderAssetId = _get(parsedMetaData, 'bynderAssetId', '');

      if (!bynderAssetId) {
        return;
      }

      setIsLoading(true);

      const { data, error } = await getBynderAssetDownloadUrl({ bynderAssetId, organisationId });

      setIsLoading(false);

      if (error) {
        console.error('Error getting download url', error);
        return;
      }

      setBynderDownloadUrl(data.getBynderAssetDownloadUrl);
    } catch (error) {
      console.error('Error getting download url', error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!asset) {
      return;
    }

    if (!asset.metaData) {
      return;
    }

    getBynderDownloadUrl(asset.metaData, asset.organisationId);
  }, []);

  const getDownloadOptions = () => {
    if (!asset || !asset.assetFiles) {
      return [];
    }

    const assetFilesKeys = [...Object.keys(asset.assetFiles)];

    const isVideo = isVideoType(asset.metaData);

    return assetFilesKeys.
    filter(isAssetExists(asset)).
    filter(() => !isVideo || canDownloadOriginalQuality(asset)).
    filter(
      (assetFileKey) => !isVideo ||
      includeOriginalQuality ||
      isAllowedDownloadOption(videoStatus, videoProduct)(assetFileKey)
    ).
    reduce(transformKeysToOptionsArray(asset), []).
    map(appendMetadataToOption).
    filter(isAssetFileValid).
    filter(({ type }) => !type || type !== 'VTT_CAPTION').
    map((assetFile) => getOptionValues(assetFile));
  };

  const options = useMemo(() => getDownloadOptions(), [asset, videoId, videoStatus]);

  if (disabled || !_get(options, 'length')) {
    return children;
  }

  const restrictDownload = Boolean(videoStatus) && videoStatus !== VIDEO_OUTPUT_STATUS.APPROVED;

  const menuButtonId = `download-asset-menu-${id}-${asset ? asset.assetId : ''}`;

  const oneOption = { id: menuButtonId, busy: isLoading };

  const showOptions = options.length !== 1;

  if (bynderDownloadUrl) {
    return (
      <div className="download-asset-menu">
        <a href={bynderDownloadUrl}>
          {React.cloneElement(children, oneOption)}
        </a>
      </div>);

  }

  return (
    <div className="download-asset-menu">
      {
      showOptions ?

      <MenuButton id={menuButtonId} customButton={children}>
              {options.map(
          ({ label, detailsRestricted, detailsEnabled, sourceUrl }) => {
            const restrictedStyles = Boolean(restrictDownload) &&
            RESTRICTED_DOWNLOAD_LABELS.includes(label);

            const text = restrictDownload ? detailsRestricted : detailsEnabled;

            return (
              <div
                key={`key-${label}`}
                style={restrictedStyles ? RESTRICTED_STYLES : {}}>

                      <Dropdown.Label
                  key={label}
                  data={{
                    label: restrictedStyles ?

                    <div>
                                <Text noMargin>{label}</Text>
                                <Text caption noMargin>{text}</Text>
                              </div> :


                    <a href={sourceUrl}>
                                <div>
                                  <Text noMargin>{label}</Text>
                                  <Text caption noMargin>{text}</Text>
                                </div>
                              </a>

                  }} />

                    </div>);

          })}
            </MenuButton> :


      <a href={options[0].sourceUrl}>
              {React.cloneElement(children, oneOption)}
            </a>}



    </div>);

};

export default memo(DownloadAssetMenu);